import { Column, ColumnKeys, osTypes, RingVersionItem } from '../types';
import { GetRowsRequest, GetSummaryResponse } from "../../../grid/types/common";

import { ConsoleRequest, DataProviderType, FilterKeyMapper } from "../../../utils/request";
import { ReadRingStagingVersionsResponse, RingVersionsMethods } from "../types";
import { Dependencies } from "../types/dependencies";
import { GridBaseDataProvider } from "../../../grid/GridBaseDataProvider";

export class CloudStagingListNirvanaDataProvider extends GridBaseDataProvider <Column, ColumnKeys> {
  private cache: ReadRingStagingVersionsResponse | null;
  private endpoint = 'RingStagingUpdateVersions';

  /**
   * Maps column key to different filter key as we filter with a different one.
   */
  private filterKeyMapper: FilterKeyMapper = {
    'company.name': 'company.id',
    'extraParams': 'extraParams',
  };


  constructor(public dependencies: Dependencies) {
    super();
  }

  public async getDataForView() {
    return {};
  }

  async getSummary(request: GetRowsRequest<Column, ColumnKeys>): Promise<GetSummaryResponse> {
    const response = await this.readRecords(request);

    return {numItems: response.total, summary: ''};
  }

  async getRows(request: GetRowsRequest<Column, ColumnKeys>): Promise<{ rawEvents: Array<RingVersionItem> }> {
    const response = await this.readRecords(request);

    return {rawEvents: response.data};
  }

  async setFilters(request: any): Promise<{} | undefined> {
    return;
  }

  private async readRecords(request: GetRowsRequest<Column, ColumnKeys>): Promise<ReadRingStagingVersionsResponse> {
    if (this.cache) {
      const response = Promise.resolve(this.cache);
      this.cache = null;

      return response;
    }
    const payload = ConsoleRequest.mapGridRequestToPayload(request, this.dependencies.getTimezone(), this.filterKeyMapper);

    payload.extraParams = request.extraParams || {};
    if (payload.extraParams.type === undefined) {
      payload.extraParams.type = osTypes.windows;
    }

    payload.extraParams.companyId = this.dependencies.getActiveCompany().companyId;

    const response = await ConsoleRequest.createRequest<any>({
      dataProviderType: DataProviderType.ENDPOINTS,
      payload,
      endpoint: this.endpoint,
      method: RingVersionsMethods.READ_RECORDS,
    });

    this.cache = response;

    return response;
  }

  async updatePinnedVersion(type: number, newStagingProfiles: Array<number>, version: string): Promise<any> {
    return await ConsoleRequest.createRequest<any>({
      dataProviderType: DataProviderType.CORE,
      endpoint: 'Company',
      method: 'updateStagingPinnedVersion',
      payload: {
        companyId: this.dependencies.getActiveCompany().companyId,
        type,
        newStagingProfiles,
        version
      }
    });
  }
}
